module.exports = __webpack_public_path__ + "static/media/cred_mod_C_secc.3e5055d7.gif";